module.exports = __webpack_public_path__ + "static/media/mail.539d28a1.svg";